export type RecursivePartial<T> = {
  [P in keyof T]?: T[P] extends (infer U)[]
    ? RecursivePartial<U>[]
    : T[P] extends object | undefined
    ? RecursivePartial<T[P]>
    : T[P];
};

export type DeepNullable<T> = {
  [K in keyof T]: DeepNullable<T[K]> | null;
};

export function extractValue(input: number | undefined | null) {
  return input != null ? input : null;
}

export function compareDates(a: string | null, b: string | null) {
  if (a === null && b === null) {
    return 0;
  }

  if (a === null) {
    return 1;
  }

  if (b === null) {
    return -1;
  }

  return new Date(a) > new Date(b) ? -1 : 1;
}

/*
Return true if none of the properties of the object are set (empty or false should be allowed on control level)
Returns false if the object is null or undefined
*/
export function isEmptyObject(obj: object): boolean {
  if (obj === null || obj === undefined) {
    return false;
  }
  return !Object.keys(obj).some(
    (property) => obj[property as keyof typeof obj] !== undefined
  );
}

export function filterUndefined<T>(x: T | undefined): x is T {
  return !!x;
}
